export default "/fonts/PublicSans-Bold.ttf?f0a9b8f70097795ff14669ef8e59a7f4";